module.exports = __webpack_public_path__ + "img/1080_10.50930688.jpg";